"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import styles from "./CookiesBanner.module.scss";
import { useCookieConsent } from "./CookieConsentContext";
import Link from "next/link";
import Image from "next/image";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useIsMobileDevice from "@/hooks/isMobileDevice";
export default function CookiesBanner() {
  const $ = _c(20);
  const {
    isApp,
    isAppleMobile
  } = useDeviceInfo();
  const isMobile = useIsMobileDevice();
  const pathname = usePathname() ?? "";
  const {
    consent,
    reject
  } = useCookieConsent();
  if (["/restricted", "/access"].includes(pathname)) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const t0 = `${styles.banner} ${isApp ? styles.bannerMobile : ""} ${isApp && isAppleMobile ? styles.bannerIOS : ""} d-flex align-items-center justify-content-between gap-2 ${isApp ? "flex-column" : ""}`;
  const t1 = isMobile ? 22 : 40;
  const t2 = isMobile ? 22 : 40;
  let t3;
  if ($[1] !== t1 || $[2] !== t2) {
    t3 = <Image unoptimized={true} src="/intern.png" alt="Cookie" width={t1} height={t2} />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="font-bolder">seize the cookies of consent</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <span className="d-flex align-items-center gap-2">{t3}{t4}</span>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== consent) {
    t6 = <button className={styles.accept} onClick={consent}>Accept</button>;
    $[7] = consent;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="font-smaller">Reject Non-Essential</span>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== reject) {
    t8 = <button className={styles.reject} onClick={reject}>{t7}</button>;
    $[10] = reject;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Link className={styles.learnMore} href="/about/cookie-policy"><span className="font-smaller">Learn more</span></Link>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t8) {
    t10 = <span className="d-flex align-items-center justify-content-between gap-3">{t6}{t8}{t9}</span>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t0 || $[17] !== t10 || $[18] !== t5) {
    t11 = <div className={t0}>{t5}{t10}</div>;
    $[16] = t0;
    $[17] = t10;
    $[18] = t5;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}